/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
// eslint-disable-next-line react/prop-types
function HidePassword({ width = 20, height = 15, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 2.78068C13.4455 2.78068 16.5182 4.44909 18.0182 7.08877C17.4818 8.04439 16.7273 8.86684 15.8273 9.53264L17.1091 10.6371C18.3727 9.67363 19.3727 8.46736 20 7.08877C18.4273 3.65013 14.5455 1.2141 10 1.2141C8.84545 1.2141 7.73636 1.37076 6.69091 1.66057L8.19091 2.953C8.78182 2.85117 9.38182 2.78068 10 2.78068ZM9.02727 3.67363L10.9091 5.29504C11.4273 5.49086 11.8455 5.85118 12.0727 6.29765L13.9545 7.91906C14.0273 7.65274 14.0818 7.37076 14.0818 7.08094C14.0909 5.13838 12.2545 3.56397 10 3.56397C9.66364 3.56397 9.34546 3.60313 9.02727 3.67363ZM0.918182 1.11227L3.35455 3.21149C1.87273 4.2141 0.7 5.54569 0 7.08877C1.57273 10.5274 5.45455 12.9634 10 12.9634C11.3818 12.9634 12.7091 12.7363 13.9273 12.3211L17.0364 15L18.3182 13.8956L2.2 0L0.918182 1.11227ZM7.73636 6.98695L10.1091 9.03133C10.0727 9.03916 10.0364 9.047 10 9.047C8.74545 9.047 7.72727 8.16971 7.72727 7.08877C7.72727 7.04961 7.73636 7.02611 7.73636 6.98695ZM4.64545 4.32376L6.23636 5.69452C6.02727 6.12533 5.90909 6.5953 5.90909 7.08877C5.90909 9.03133 7.74545 10.6136 10 10.6136C10.5727 10.6136 11.1182 10.5118 11.6091 10.3316L12.5 11.0992C11.7 11.2872 10.8636 11.3969 10 11.3969C6.55455 11.3969 3.48182 9.72846 1.98182 7.08877C2.61818 5.96867 3.54545 5.04439 4.64545 4.32376Z"
        fill="#9E9E9E"
      />
    </svg>
  );
}
export default HidePassword;
